import { createId } from "../../utils/string";

export default {
  name: "flow-effect",
  render(h) {
    return h(
      "div",
      this.$scopedSlots.default ? this.$scopedSlots.default({}) : []
    );
  },
  props: {
    id: [String, Number],
    speed: {
      type: Array,
      default() {
        return [0, 0];
      },
    },
    play: {
      type: Boolean,
      default: true,
    },
  },
  inject: {
    bimface: {
      default: {
        viewer3D: null,
        animationContainer: null,
      },
    },
    material: {
      default: {
        instance: null,
      },
    },
  },
  watch: {
    "material.instance": function (newVal, oldVal) {
      this.init(this.animationContainer, newVal, this.viewer3D);
    },
    play(newVal) {
      if (!this.instance) return;
      if (newVal) {
        this.instance.play();
      } else {
        this.instance.stop();
      }
    },
    speed(newVal) {
      this.instance && this.instance.setSpeed(newVal);
    },
  },
  data() {
    return {
      instance: null,
    };
  },
  computed: {
    animationContainer() {
      return this.bimface.animationContainer;
    },
    viewer3D() {
      return this.bimface.viewer3D;
    },
  },
  methods: {
    init(animationContainer, material, viewer3D) {
      let config = new Glodon.Bimface.Plugins.Animation.FlowEffectConfig();

      config.material = material;
      this.speed && (config.speed = this.speed);

      config.viewer = viewer3D;
      config.id = this.id || createId();

      this.instance = new Glodon.Bimface.Plugins.Animation.FlowEffect(config);

      this.play && this.instance.play();
    },
  },
};
